<style scoped>
.tax_info_row {
	background: #EEEEEE;
	margin-bottom: 5px;
	padding: 5px;
}

.tax_info_row:hover {
	background: #DDDDDD;
}

</style>

<template>
	<div class="tax_info_row" @click="edit_tax_empinfo()">
		<div>
			<span>Tax info</span>
			<span> from {{ start_date }}</span>
			<span v-if="tax_empinfo.end_date"> until {{ end_date }}</span>
			<span>, {{ tax_empinfo.status_desc }}</span>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	props: {
		tax_empinfo: {
			type: Object,
			default: null
		},
		popup_editors: { // when used in the desktop app, we want to popup a new window so Omnis can catch this.
			type: Boolean,
			default: false
		},
	},
	computed: {
		start_date() {
			return moment(this.tax_empinfo.start_date).format("DD MMMM YYYY");
		},
		end_date() {
			if (this.tax_empinfo.end_date) {
				return moment(this.tax_empinfo.end_date).format("DD MMMM YYYY");
			} else {
				return '';
			}
		},
	},
	methods: {
		edit_tax_empinfo() {
			if (this.popup_editors) {
				window.open('/desktop/addressbook/' + this.tax_empinfo.addressbook_id + '/payroll_header/' + this.tax_empinfo.payroll_header_id + '/taxinfo/' + this.tax_empinfo.id)
			} else {
				// route to edit URL once we implement the web interface for this
			}
		},
	},
}
</script>
